document.addEventListener('DOMContentLoaded', function() {
  const modals = document.querySelectorAll('.waitlist-modal');
  
  modals.forEach(modal => {
    const overlay = modal.querySelector('.modal-overlay');
    const content = modal.querySelector('.form-wrapper-relative');

    overlay.addEventListener('click', () => modal.open = false);
    content.addEventListener('click', (e) => e.stopPropagation());
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      modals.forEach(m => m.open = false);
    }
  });
});